import { Button, Center, Skeleton, Text } from "@chakra-ui/react";
import { CellContext } from "@tanstack/react-table";

export type TStatesDataTableData = {
  primaryKey: number | string,
  stateParameter: string,
  defaultValue: string,
  value: string,
  [x: string]: string | number | boolean,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void
};

export function getStatesDataTableColumns( { isLoading, handleEdit }: Props ) {
    // console.table(meta.rowsFields);
      return [
        {
        //   accessorKey: "",
          id: "entry",
          header: "",
          cell: (info: CellContext<any, any>) => {
            return (
                <Skeleton isLoaded={!isLoading}>
                    <Text textAlign={"end"}>{info.row.original.entry}</Text>
                </Skeleton>
            );
          }
        },
  
        {
          accessorKey: "stateParameter",
          id: "stateParameter",
          header: () => "State Parameter",
          cell: (info: CellContext<any, any>) => {
            return (
              <Skeleton isLoaded={!isLoading}>
                {info.getValue()}
              </Skeleton>
            );
          }
        },
  
        {
          accessorKey: "defaultValue",
          id: "defaultValue",
          header: () => "Default Value",
          cell: (info: CellContext<any, any>) => {
            return (
                <Skeleton isLoaded={!isLoading}>
                    {info.getValue()}
                </Skeleton>
            );
          }
        },
  
        {
          accessorKey: "value",
          id: "value",
          header: () => "Value",
          cell: (info: CellContext<any, any>) => {
            return (
                <Skeleton isLoaded={!isLoading}>
                    <Center>
                        {info.getValue()}
                    </Center>
                </Skeleton>
            );
          }
          
        },
  
        {
        //   accessorKey: "",
          id: "action",
          header: "",
          cell: (info: CellContext<any, any>) => {
            
            return (
                <Skeleton isLoaded={!isLoading}>
                    <Center>
                        <Button size={"sm"} onClick={() => handleEdit(info.row)} mr={"1rem"}>Editer</Button>
                    </Center>

                </Skeleton>
            );
          }
        },
             
      ];
    }
